import { createContext, useEffect, useState } from "react";

export const LoadingContext = createContext();

const LoadingContextProvider = (props) => {
	const [loadingData, setLoadingData] = useState({ is_loading: false, message: "" });

	console.log("loading: ", loadingData);

	useEffect(() => {
		if (loadingData.is_loading) {
			setTimeout(() => {
				setLoadingData({
					...loadingData,
					is_loading: false,
					message: "",
					is_success: false,
				});
			}, 10000);
		}
	}, [loadingData]);

	return (
		<LoadingContext.Provider value={{ loadingData, setLoadingData }}>
			{props.children}
		</LoadingContext.Provider>
	);
};

export default LoadingContextProvider;
